export const DefaultColorPalette = [
  '#ffb300', // vivid yellow
  '#a6bdd7', // very light blue
  '#c10020', // vivid red
  '#803e75', // strong purple
  '#cea262', // grayish yellow
  '#817066', // medium gray
  '#ff6800', // vivid orange

  // The following will not be good for people with defective color vision
  '#007d34', // vivid green
  '#f6768e', // strong purplish pink
  '#00538a', // strong blue
  '#ff7a5c', // strong yellowish pink
  '#53377a', // strong violet
  '#ff8e00', // vivid orange yellow
  '#b32851', // strong purplish red
  '#f4c800', // vivid greenish yellow
  '#7f180d', // strong reddish brown
  '#93aa00', // vivid yellowish green
  '#593315', // deep yellowish brown
  '#f13a13', // vivid reddish orange
  '#232c16', // dark olive green
] as const;

export const maxPaletteSize = DefaultColorPalette.length;
